module.exports = "/_next/static/images/mobile-application-banner-mobile-4ef82f8cde5701e040444ba0bcebe95a.webp";